/**
 *  Contains a dictionary of all the Action Buttons
 *  Easily build an action button
 */
namespace appn.actionButtons {
    export const BUTTONS: IActionButtons = appn.actionButtons.BUTTONS;
    const _buttonTemplate = '<button id="%0%" class="btn %1% %5%" %4%><span>%2%</span><i class="%3%"></i></button>';

    export function getButton(buttonId: string, buttonType: string, isDisabled?: boolean, buttonText?: string, isDataTableToggleBtn?: boolean): string {

        const currentBtn = appn.actionButtons.BUTTONS[buttonType];
        let button = _buttonTemplate.replace('%0%', buttonId)
            .replace('%1%', currentBtn.ButtonColourClass)
            .replace('%2%', buttonText ? buttonText : T(currentBtn.Text))       // don't translate explicitly provided buttonText, assume already done by caller
            .replace('%3%', currentBtn.IconClass);

        if (isDataTableToggleBtn) {
            button = button.replace('%5%', 'btn-sm datatable-togglebtn');
            isDisabled = true;
        } else
            button = button.replace('%5%', appn.emptyString);

        if (isDisabled)
            button = button.replace('%4%', 'disabled="disabled"');
        else
            button = button.replace('%4%', appn.emptyString);

        return button;
    }

    export function getButtonAndAppendTo(buttonId: string, buttonType: string, appendTo: JQuery<HTMLElement>, isDisabled?: boolean, buttonText?: string, isDataTableToggleBtn?: boolean) {
        $('#' + buttonId).remove();
        appendTo.append(getButton(buttonId, buttonType, isDisabled, buttonText, isDataTableToggleBtn));
    }

    export function getButtonAndPrependTo(buttonId: string, buttonType: string, prependTo: JQuery<HTMLElement>, isDisabled?: boolean, buttonText?: string, isDataTableToggleBtn?: boolean) {
        $('#' + buttonId).remove();
        prependTo.prepend(getButton(buttonId, buttonType, isDisabled, buttonText, isDataTableToggleBtn));
    }

    export function renderNavbarActionButtons(actionButtonConfigs: IActionButtonConfig[], userIsPermitted: boolean, appendToDataTableAction?: boolean) {

        if (!userIsPermitted || !actionButtonConfigs || actionButtonConfigs.length < 1)
            return;

        const $toolbar = !appendToDataTableAction ? $('.navbar-nav-right') : $('.dataTables_controls_start');

        for (let i = 0; i < actionButtonConfigs.length; i++)
            getButtonAndAppendTo(
                actionButtonConfigs[i].buttonId,
                actionButtonConfigs[i].buttonType,
                $toolbar,
                actionButtonConfigs[i].isDisabled,
                actionButtonConfigs[i].buttonText,
                actionButtonConfigs[i].isDataTableToggleBtn
            );
    }
}
